import React from 'react';
import { Switch as HeadlessSwitch } from '@headlessui/react';
import { cn } from './utils';

export interface SwitchProps {
  checked: boolean;
  onChange: (checked: boolean) => void;
  disabled?: boolean;
  className?: string;
  name?: string;
  id?: string;
  'aria-label'?: string;
  'aria-labelledby'?: string;
}

export function Switch({
  checked,
  onChange,
  disabled,
  className,
  name,
  id,
  'aria-label': ariaLabel,
  'aria-labelledby': ariaLabelledBy,
}: SwitchProps) {
  return (
    <HeadlessSwitch
      checked={checked}
      onChange={onChange}
      disabled={disabled}
      name={name}
      id={id}
      aria-label={ariaLabel}
      aria-labelledby={ariaLabelledBy}
      className={cn('bh-switch', checked && 'bh-switch--checked', className)}
    >
      <span aria-hidden className="bh-switch__thumb" />
    </HeadlessSwitch>
  );
}
